import React from 'react'
import FooterNavMildiou from './MEP/footer-nav-mildiou'
import EnteteMildiou from './MEP/enete-milidou'

function MesParcelles() {
  return (
    <div>
        <EnteteMildiou titre={'Mes parcelles'}/>
        <FooterNavMildiou/>
        <div className='containerMildiou'> 
            Mes parcelles
        </div>
    </div>
  )
}

export default MesParcelles